import { render, staticRenderFns } from "./RefundsCancellationsView.vue?vue&type=template&id=08c299ca&scoped=true&style=background-color%3A%20transparent%3B%20position%3Arelative%3B"
import script from "./RefundsCancellationsView.vue?vue&type=script&lang=js"
export * from "./RefundsCancellationsView.vue?vue&type=script&lang=js"
import style0 from "./RefundsCancellationsView.vue?vue&type=style&index=0&id=08c299ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c299ca",
  null
  
)

export default component.exports